import React from 'react';
import { Card, CardContent, Grid, Typography, Box } from '@mui/material';

const ServiceComponent = () => {
  return (
    <Box
      sx={{
        backgroundColor: '',
        padding: { xs: '20px', sm: '40px' },
        color: '#fff',
      }}
    >
      <Typography
        variant='h4'
        sx={{
          textAlign: 'center',
          color: '#172554',
          marginBottom: { xs: '20px', sm: '10px' },
          fontSize: { xs: '24px', sm: '32px' },
        }}
        className='component'
      >
        Our Assured Quality and Our Additional Services
      </Typography>

      <Grid container spacing={3} justifyContent="center">
        {/* Left Side: 3 Cards */}
        <Grid item xs={12} sm={6} md={3}>
          <Card
            sx={{
              backgroundColor: 'transparent',
              color: '#172554',
              marginBottom: '16px',
              boxShadow: '0px 0px 0px 0px',
            }}
          >
            <CardContent className='component'>
              <Typography variant="h6">
                <i
                  className="fa-solid fa-circle-info"
                  style={{ paddingRight: '10px', color: '#f97316' }}
                ></i>
                Basic
              </Typography>
              <Typography variant="body2" color={"black"}>
                This research explores the transformative impact of Artificial Intelligence on healthcare delivery, focusing on advanced features, with a bibliography for further reading.
              </Typography>
            </CardContent>
          </Card>
          <Card
            sx={{
              backgroundColor: 'transparent',
              color: '#172554',
              marginBottom: '16px',
              boxShadow: '0px 0px 0px 0px',
            }}
          >
            <CardContent className='component'>
              <Typography variant="h6">
                <i
                  className="fa-solid fa-circle-info"
                  style={{ paddingRight: '10px', color: '#f97316' }}
                ></i>
                Advanced
              </Typography>
              <Typography variant="body2" color={"black"}>
                This document outlines a comprehensive approach to problem identification, including risk assessment objectives, a structured research aim, specific objectives, and suggestions for future work.
              </Typography>
            </CardContent>
          </Card>
          <Card
            sx={{
              backgroundColor: 'transparent',
              color: '#172554',
              marginBottom: '16px',
              boxShadow: '0px 0px 0px 0px',
            }}
          >
            <CardContent className='component'>
              <Typography variant="h6">
                <i
                  className="fa-solid fa-circle-info"
                  style={{ paddingRight: '10px', color: '#f97316' }}
                ></i>
                Extended
              </Typography>
              <Typography variant="body2" color={"black"}>
                This research examines the impact of Artificial Intelligence on healthcare, focusing on advanced features, expected contributions, ethical challenges, and research gaps, with a bibliography for further reading.
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Center Circle */}
        <Grid item xs={12} sm={6} md={3} display="flex" justifyContent="center" alignItems="center">
          <Box
            sx={{
              width: { xs: 150, sm: 180, md: 200 },
              height: { xs: 150, sm: 180, md: 200 },
              backgroundColor: '#172554',
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              color: '#ffffff',
              textAlign: 'center',
              boxShadow: '0px 0px 20px rgba(0,0,0,0.1)',
              marginBottom: '16px',
            }}
          >
            <Typography
              variant="h6"
              color={'white'}
              sx={{ textAlign: 'center', fontSize: { xs: '18px', sm: '20px', md: '25px' } }}
              className='component'
            >
              Services Description
            </Typography>
          </Box>
        </Grid>

        {/* Right Side: 3 Cards */}
        <Grid item xs={12} sm={6} md={3}>
          <Card
            sx={{
              backgroundColor: 'transparent',
              color: '#172554',
              marginBottom: '16px',
              boxShadow: '0px 0px 0px 0px',
            }}
          >
            <CardContent className='component'>
              <Typography variant="h6">
                <i
                  className="fa-solid fa-circle-check"
                  style={{ paddingRight: '10px', color: '#f97316' }}
                ></i>
                Well Documented
              </Typography>
              <Typography variant="body2" color={"black"}>
                In academic writing, particularly in a PhD thesis, rephrasing information while maintaining its original meaning is often referred to as paraphrasing...
              </Typography>
            </CardContent>
          </Card>
          <Card
            sx={{
              backgroundColor: 'transparent',
              color: '#172554',
              marginBottom: '16px',
              boxShadow: '0px 0px 0px 0px',
            }}
          >
            <CardContent className='component'>
              <Typography variant="h6">
                <i
                  className="fa-solid fa-circle-check"
                  style={{ paddingRight: '10px', color: '#f97316' }}
                ></i>
                Structuring & Referring
              </Typography>
              <Typography variant="body2" color={"black"}>
                The research report adheres to the recommended formatting guidelines. Our team ensures proper attribution, prevents plagiarism, and includes essential elements like a table of contents and lists of tables and figures.
              </Typography>
            </CardContent>
          </Card>
          <Card
            sx={{
              backgroundColor: 'transparent',
              color: '#172554',
              marginBottom: '16px',
              boxShadow: '0px 0px 0px 0px',
            }}
          >
            <CardContent className='component'>
              <Typography variant="h6">
                <i
                  className="fa-solid fa-circle-check"
                  style={{ paddingRight: '10px', color: '#f97316' }}
                ></i>
                Educational resource sharing
              </Typography>
              <Typography variant="body2" color={"black"}>
                We deliver your work along with a comprehensive list of reference materials. Upon request, we can highlight key resources and share additional materials via a zipped file on Google Drive or Dropbox.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ServiceComponent;
